import React, { useCallback, useRef, useEffect } from "react";
import type { IGenre, AppDispatch } from "@litres-core/store";
import { useDispatch } from "react-redux";
import cn from "classnames";
import { api, useAppSelector } from "@litres-core/store";
import { SmartLink } from "@litres-modules/smart-link";
import { SpriteIcon } from "@litres-libs/sprite-icons";
import type { AllGenresProps } from "../types";
import { Column } from "./Column/Column";
import styles from "./AllGenres.module.scss";

export const AllGenres = (props: AllGenresProps): JSX.Element => {
  const { genres, isLoading, isOpen, isPreview, showPreview } = props;
  const dispatch = useDispatch<AppDispatch>();
  const containerRef = useRef<HTMLDivElement>(null);

  const clientHost = useAppSelector(
    state => state.browser.headers["client-host"]
  );

  const closeHandler = useCallback(() => {
    if (isPreview) {
      showPreview(false);
    }

    dispatch(api.global.genres.setOpenPopup(false));
    dispatch(api.global.genres.setCurrentGenre(null));
    dispatch(api.global.genres.setHistory([]));
  }, [isPreview]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  if (genres) {
    return (
      <div className={styles["genres-wrapper"]} ref={containerRef}>
        <SmartLink className={styles["close-icon"]} onClick={closeHandler}>
          <SpriteIcon name="close" size={24} />
        </SmartLink>
        {
          /** При подгрузке жанров показываем юзеру что грузимся, чтобы не смущать почему жанры перестроятся после подгрузки */
          isLoading && <span className={styles.genresLoadingIcon} />
        }

        <div
          className={cn(
            styles["genres-container"],
            isLoading && styles.isLoading
          )}
        >
          {genres.map((genre: IGenre, index: number) => {
            const { id } = genre;

            if (index > 13) {
              return null;
            }

            return <Column genre={genre} key={id} showPreview={showPreview} />;
          })}
          <Column
            genre={{
              url: "/selfpublishing/",
              id: 6334,
              name: "Эксклюзивы",
            }}
            showPreview={showPreview}
          />
          <Column
            genre={{
              url: "/drafts/",
              id: 223845,
              name: "Черновики",
            }}
            showPreview={showPreview}
          />
          {clientHost === "www.litres.ru" && (
            <Column
              genre={{
                url: "/showroom/fanfic/",
                id: 126859,
                name: "Фанфики",
              }}
              showPreview={showPreview}
            />
          )}
          <Column
            genre={{
              url: "/collections/besplatnie-knigi/",
              id: -3,
              name: "Бесплатные книги",
            }}
            showPreview={showPreview}
          />
        </div>
      </div>
    );
  }
  return <></>;
};
